import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import React, { FC } from 'react';

export interface HlIconProps extends React.HTMLAttributes<HTMLSpanElement> {
  icon: IconProp;
  className?: string;
  size:
    | 'xxsmall'
    | 'xsmall'
    | 'small'
    | 'medium'
    | 'large'
    | 'xlarge'
    | 'xxlarge';
}

export const HlIcon: FC<HlIconProps> = ({
  icon,
  className,
  size,
  ...props
}) => {
  return (
    <span className={clsx('hl-icon', `icon-${size}`, className)} {...props}>
      <FontAwesomeIcon icon={icon} />
    </span>
  );
};

export default HlIcon;
